export default {
	GET_AUTH: state => state.auth,
}